import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from '../../common/AjaxRequest';
import { Form, Input, Modal, Row, Col, Select, message, InputNumber, DatePicker, Spin, Cascader } from 'antd';
import { getMatchOption } from '../shared/selectFn';
import autoEval from '../shared/autoEvaluation';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import API_URL from '../../common/url';
import './css/list.less';
import { saveCreateParams as saveParams } from '../../actions/investigationActions';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const dateFormat = 'YYYY-MM-DD';
const DefaultList = [
    { label: '是', value: 1 },
    { label: '否', value: 0 },
];

let Constants = {};
const getStatusByType = (type) => {
    switch(type) {
        case 'add':
            return {
                add: true,
                title: '添加项目',
                success: '添加成功',
                saveUrl: API_URL.investigation.create,
            };
    }
};

class CreateForm extends Component {
    state = {
        disease: {},
        byStageList: [],
    }

    componentDidMount() {
        const { form } = this.props;
        const { getFieldDecorator, setFieldsValue } = form;
        const { investigationMedicineType: oldMedicineType, secondResearchProductType } = saveParams;
        getFieldDecorator('diseaseClassName', { initialValue: undefined });
        getFieldDecorator('investigationAreaId', { initialValue: undefined });
        getFieldDecorator('investigationAreaName', { initialValue: undefined });
        getFieldDecorator('invAreaGroupType', { initialValue: undefined });
        getFieldDecorator('bdUserName', { initialValue: undefined });
        getFieldDecorator('investigationSponsor', { initialValue: undefined });
        getFieldDecorator('cro', { initialValue: undefined });
        getFieldDecorator('diseaseName', { initialValue: undefined });
        getFieldDecorator('lineOfBusinessString', { initialValue: undefined });
        getFieldDecorator('typeId', { initialValue: undefined });
        getFieldDecorator('investigationTypeName', { initialValue: undefined });
        setFieldsValue({ 
            investigationMedicineType: secondResearchProductType ? [oldMedicineType, secondResearchProductType] : [oldMedicineType],
        })
    }

    loadInvestigationByStageList = (investigationMedicineType) => {
        if (!investigationMedicineType || (investigationMedicineType && investigationMedicineType.length == 0)) {
            this.setState({ byStageList: [] });
        } else {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType: investigationMedicineType[0] },
                dataType: 'json',
                doneResult: data => {
                    this.setState({ byStageList: data.data });
                }
            };
            $.sendRequest(options);
        }
    }

    handleChange = (value, key) => {
        const { form } = this.props;
        const { setFieldsValue, getFieldValue } = form;
        switch (key) {
            case 'investigationName': {
                setTimeout(this.autoEvaluation, 30);
                return value;
            }
            case 'stageIds': {
                const { levelList, stageList } = this.props;
                const params = { suspendTime: undefined };
                let newValue = (value || []).slice();
                if (newValue.length >= 2) {
                    let lastValue;
                    const { groupId: fg } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                    const { groupId: lg } = getMatchOption(stageList, 'typeConfigureId', (lastValue = newValue.slice(-1))[0]);
                    if (fg !== lg) {
                        newValue = lastValue;
                    }
                }

                const { typeValue } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                if (typeValue === '治疗结束随访期' || typeValue === '项目暂停') {
                    const levelId = getFieldValue('levelId');
                    const { typeValue: level } = getMatchOption(levelList, 'typeConfigureId', levelId);
                    if (level && level !== 'C') {
                        params.levelId = levelId + 1;
                    }
                }
                setFieldsValue(params);
                return newValue;
            }
            case 'isClinicalProject': {
                if (value == 1) {
                    setTimeout(this.autoEvaluation, 30);
                } else {
                    setFieldsValue({ lineOfBusiness: undefined });
                }
                return value;
            }
            case 'investigationMedicineType': {
                setFieldsValue({
                    treatmentMethod: undefined,
                    drugMainTargets: undefined,
                    administrationMode: undefined,
                    administrationModeRemark: undefined,
                    investigationMedicine: undefined,
                    investigationByStageId: [],
                    investigationByStageRemark: undefined,
                });
                this.loadInvestigationByStageList(value);
                setTimeout(this.autoEvaluation, 30);
                return value;
            }
            case 'administrationMode':
                setFieldsValue({ administrationModeRemark: undefined });
                return value;
            case 'investigationByStageId': {
                const { byStageList } = this.state;
                const { isMultipleChoice, investigationByStageId } = getMatchOption(byStageList, 'investigationByStageId', (value || []).slice(-1));
                setFieldsValue({ investigationByStageRemark: undefined });
                setTimeout(this.autoEvaluation, 30);
                return isMultipleChoice == 1 ? value : investigationByStageId ? [String(investigationByStageId)] : [];
            }
            case 'testeeTypeId': {
                setTimeout(this.autoEvaluation, 30);
                return value;
            }
            case 'disease': {
                const { value: diseaseId, text: diseaseName, diseaseClassName, investigationAreaId, investigationAreaName, invAreaGroupType } = value;
                setFieldsValue({
                    diseaseId,
                    diseaseName: diseaseName ? diseaseName.replace(/^(NA)\(.+\)$/, '$1') : undefined,
                    diseaseClassName,
                    investigationAreaId,
                    investigationAreaName,
                    invAreaGroupType,
                });
                this.setState({ disease: value }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'sponsor': {
                const { value: id, text: name } = value;
                setFieldsValue({
                    investigationSponsor: name,
                    investigationSponsorId: id,
                });
                break;
            }
            case 'cro': {
                const { value: id, text: name } = value;
                setFieldsValue({
                    cro: name,
                    croId: id,
                });
                break;
            }
            case 'bd': {
                const { value: id, text: name } = value;
                setFieldsValue({
                    bdUserId: id,
                    bdUserName: name,
                });
                break;
            }
            case 'investigationGlobalType': {
                setFieldsValue({
                    levelId: value == 'Internal_Single' ? 3 : 2,
                });
                return value;
            }
            default:
                return value;
        }
    }

    autoEvaluation = () => {
        const { typeList, testeeTypeList, businessList, form } = this.props;
        const { byStageList, disease } = this.state;
        const { getFieldsValue, setFieldsValue } = form;
        const {
            isClinicalProject, investigationMedicineType, investigationByStageId,
            investigationAreaName, testeeTypeId, investigationName, invAreaGroupType
        } = getFieldsValue();

        const params = autoEval({
            type: 'CTA',
            businessList,
            byStageList,
            typeList,
            testeeTypeList,
            disease,
            isClinicalProject,
            investigationMedicineType,
            investigationByStageId,
            investigationAreaName,
            invAreaGroupType,
            testeeTypeId,
            investigationName
        });

        setFieldsValue(params);
    }

    render() {
        const {
            form,
            levelList,
            stageList,
            businessList,
            testeeTypeList,
            GlobalTypeList,
            MedicineTypeList,
            treatmentMethodList,
            administrationModeList,
        } = this.props;
        const { byStageList } = this.state;
        const { getFieldDecorator, getFieldsValue, getFieldValue } = form;
        const isClinicalProject = getFieldValue('isClinicalProject');
        const {
            stageIds,
            diseaseName,
            investigationMedicineType = [],
            investigationByStageId,
            administrationMode,
            cro,
            bdUserName,
            investigationSponsor,
            diseaseClassName,
            investigationAreaName,
            investigationTypeName,
        } = getFieldsValue();

        // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
        let multiplable = true;
        let showStageOther = false;
        if ((investigationByStageId || []).length === 1) {
            const { isMultipleChoice, investigationByStageName } = getMatchOption(byStageList, 'investigationByStageId', investigationByStageId[0]);
            multiplable = isMultipleChoice == 1;
            showStageOther = investigationByStageName === '其他';
        }
        
        const isClinicalPro = isClinicalProject == 1;
        const { typeValue: stageName } = getMatchOption(stageList, 'typeConfigureId', (stageIds || []).slice(-1).join());
        const showAdministrationModeOther = getMatchOption(administrationModeList, 'typeConfigureId', administrationMode).typeValue === '其他';

        const defaultOption = DefaultList.map(d => <Option key={d.value} value={d.value}>{d.label}</Option>);
        const levelOption = levelList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const stageOption = stageList.filter(d => d.operation !== 'INVESTIGATION_DATA_LOCK' && d.operation !== 'INVESTIGATION_LEVEL_LOWEST')
            .map(d => <Option key={String(d.typeConfigureId)} disabled={d.typeValue === '项目待终止' || d.typeValue === '服务合同签署前终止' || d.typeValue === '业务数据归档'}>{d.typeValue}</Option>);
        // const medicineTypeOptions = MedicineTypeList.map(i => <Option key={String(i.value)}>{i.label}</Option>);
        const byStageOption = byStageList.map(d => <Option key={String(d.investigationByStageId)} disabled={(investigationByStageId || []).length ? multiplable ? d.isMultipleChoice == 0 : d.isMultipleChoice == 1 : false}>{d.investigationByStageName}</Option>);
        const treatmentMethodOption = treatmentMethodList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const administrationModeOption = administrationModeList.map(d => <Option key={d.typeConfigureId} value={d.typeConfigureId}>{d.typeValue}</Option>);
        const businessOption = businessList.map(i => <Option key={String(i.typeConfigureId)} disabled={!(i.groupId == 2)}>{i.typeValue}</Option>);
        const globalTypeOption = GlobalTypeList.map(d => <Option key={d.value}>{d.label}</Option>);
        const testeeTypeOption = testeeTypeList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);

        const maxLayout = {
            labelCol: {
                sm: { span: 6, pull: 1 },
                md: { span: 6, pull: 1 },
            },
            wrapperCol: {
                sm: { span: 18, pull: 1 },
                md: { span: 18, pull: 1 },
            },
        };
        const commonLayout = {
            labelCol: {
                sm: { span: 12, pull: 2 },
                md: { span: 12, pull: 2 },
            },
            wrapperCol: {
                sm: { span: 12, pull: 2 },
                md: { span: 12, pull: 2 },
            },
        };
        return (
            <Form>
                <div>1.基本信息</div>
                <Row>
                    <Col span={24}>
                        <FormItem label="项目简称" {...maxLayout}>
                            {
                                getFieldDecorator('investigationName', {
                                    getValueFromEvent: e => this.handleChange(e.target.value, 'investigationName'),
                                    rules: [
                                        { required: true, message: '项目简称不能为空', max: 200 },
                                    ],
                                })(<Input placeholder="请输入" />)
                            }
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem label="项目名称" {...maxLayout}>
                            {
                                getFieldDecorator('investigationSpecialName')(
                                    <TextArea placeholder="请输入" autosize={{ minRows: 2, maxRows: 3 }} />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目编号" {...commonLayout}>
                            {
                                getFieldDecorator('investigationCode', {
                                    rules: [
                                        { max: 30, message: '项目编号最多30个字符' },
                                    ],
                                })(
                                    <Input placeholder="请输入" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目类型" {...commonLayout}>
                            {
                                getFieldDecorator('investigationGlobalType', {
                                    getValueFromEvent: value => this.handleChange(value, 'investigationGlobalType'),
                                    rules: [
                                        { required: true, message: '请选择项目类型' },
                                    ],
                                })(
                                    <Select placeholder="请选择">{globalTypeOption}</Select>
                                )
                            }
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <FormItem label="项目级别" {...commonLayout}>
                            {
                                getFieldDecorator('levelId', {

                                    rules: [
                                        { required: true, message: '请选择项目级别' },
                                    ],
                                })(
                                    <Select placeholder="请选择">{levelOption}</Select>
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目阶段" {...commonLayout}>
                            {
                                getFieldDecorator('stageIds', {
                                    getValueFromEvent: value => this.handleChange(value, 'stageIds'),
                                    rules: [
                                        { required: true, message: '请选择项目阶段' },
                                    ],
                                })(
                                    <Select
                                        mode="multiple"
                                        allowClear={true}
                                        placeholder="请选择"
                                    >
                                        {stageOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                        {
                            stageName === '项目暂停' &&
                                <FormItem label="项目暂停时间" {...commonLayout}>
                                    {
                                        getFieldDecorator('suspendTime', {
                                            rules: [
                                                { required: true, message: '请选择项目暂停时间' },
                                            ],
                                        })(
                                            <DatePicker
                                                style={{ width: '100%' }}
                                                format={dateFormat}
                                                placeholder="请选择"
                                            />
                                        )
                                    }
                                </FormItem>
                        }
                    </Col>
                    <Col span={12}>
                        <FormItem label="此项目是否为临床项目" {...commonLayout}>
                            {
                                getFieldDecorator('isClinicalProject', {
                                    getValueFromEvent: value => this.handleChange(value, 'isClinicalProject'),
                                    rules: [
                                        { required: true, message: '请选择此项目是否为临床项目' },
                                    ],
                                })(
                                    <Select placeholder="请选择">{defaultOption}</Select>
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="研究产品类型" {...commonLayout}>
                            {
                                getFieldDecorator('investigationMedicineType', {
                                    rules: [
                                        { required: true, message: '请选择研究产品类型' },
                                    ],
                                    getValueFromEvent: value => this.handleChange(value, 'investigationMedicineType')
                                })(
                                    <Cascader
                                        placeholder="请选择"
                                        options={MedicineTypeList}
                                    />
                                )
                            }
                        </FormItem>
                        {
                            (investigationMedicineType[0] === 'Research_drugs' || investigationMedicineType[0] === 'Technology') &&
                            <FormItem label="治疗方式" {...commonLayout}>
                                {
                                    getFieldDecorator('treatmentMethod')(
                                        <Select allowClear={true} placeholder="请选择">{treatmentMethodOption}</Select>
                                    )
                                }
                            </FormItem>
                        }
                        {
                            investigationMedicineType[0] &&
                            <FormItem label="药物(疗法)分类/主要作用靶点" {...commonLayout} >
                                {
                                    getFieldDecorator('drugMainTargets')(
                                        <Input placeholder="请输入" />
                                    )
                                }
                            </FormItem>
                        }
                        {
                            investigationMedicineType[0] &&
                            <FormItem label={investigationMedicineType[0] == 'Research_drugs' ? '研究药物通用名称' : investigationMedicineType[0] == 'Technology' ? '技术名称' : '产品具体名称'} {...commonLayout}>
                                {
                                    getFieldDecorator('investigationMedicine')(
                                        <Input placeholder="请输入" />
                                    )
                                }
                            </FormItem>
                        }
                        {
                            investigationMedicineType[0] == 'Research_drugs' &&
                            <FormItem label="给药方式" {...commonLayout}>
                                {
                                    getFieldDecorator('administrationMode', {
                                        getValueFromEvent: value => this.handleChange(value, 'administrationMode')
                                    })(
                                        <Select allowClear={true} placeholder="请选择">{administrationModeOption}</Select>
                                    )
                                }
                            </FormItem>
                        }
                        {
                            (investigationMedicineType[0] == 'Research_drugs' && showAdministrationModeOther) &&
                            <FormItem label="其他给药方式备注" {...commonLayout}>
                                {
                                    getFieldDecorator('administrationModeRemark')(
                                        <Input placeholder="请输入" />
                                    )
                                }
                            </FormItem>
                        }
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目分期" {...commonLayout}>
                            {
                                getFieldDecorator('investigationByStageId', {
                                    rules: [
                                        { required: true, message: '请选择项目分期' },
                                    ],
                                    getValueFromEvent: value => this.handleChange(value, 'investigationByStageId')
                                })(
                                    <Select
                                        mode="multiple"
                                        allowClear={true}
                                        placeholder="请选择"
                                        disabled={!investigationMedicineType[0]}
                                    >
                                        {byStageOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                        {
                            showStageOther &&
                            <FormItem label="其他项目分期备注" {...commonLayout}>
                                {
                                    getFieldDecorator('investigationByStageRemark', {
                                        rules: [
                                            { required: true, message: '请输入备注' },
                                        ],
                                    })(
                                        <Input placeholder="请输入" />
                                    )
                                }
                            </FormItem>
                        }
                    </Col>
                    <Col span={12}>
                        <FormItem label="疾病" {...commonLayout}>
                            {
                                getFieldDecorator('diseaseId', {
                                    rules: [
                                        { required: true, message: '请选择疾病' },
                                    ],
                                })(
                                    <Input type="hidden" />
                                )
                            }
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                value={diseaseName}
                                params={{ limit: 20, investigationMedicineType: investigationMedicineType[0] }}
                                url={API_URL.common.queryAllDiseaseList}
                                config={{ id: 'diseaseId', name: 'diseaseName', show: 'disease' }}
                                onChange={option => this.handleChange(option, 'disease')}
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <FormItem label="疾病分类" {...commonLayout}>
                            { diseaseClassName }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目领域" {...commonLayout}>
                            {investigationAreaName }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="受试者类型" {...commonLayout}>
                            {
                                getFieldDecorator('testeeTypeId', {
                                    rules: [
                                        { required: true, message: '请选择受试者类型' },
                                    ],
                                    getValueFromEvent: value => this.handleChange(value, 'testeeTypeId')
                                })(
                                    <Select placeholder="请选择">{testeeTypeOption}</Select>
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="业务线" {...commonLayout}>
                            {
                                getFieldDecorator('lineOfBusiness', {
                                    rules: [
                                        { required: true, message: '请选择业务线' },
                                    ],
                                })(
                                    <Select disabled={isClinicalPro} placeholder="请输入">
                                        {businessOption}
                                    </Select>
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="项目分类" {...commonLayout}>
                            { investigationTypeName }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="申办方" {...commonLayout}>
                            {
                                getFieldDecorator('investigationSponsorId', {
                                    rules: [
                                        { required: true, message: '请选择申办方' },
                                    ],
                                })(
                                    <Input type="hidden" />
                                )
                            }
                            <SearchRetrieve
                                keyword='customerCompanyName'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                value={investigationSponsor}
                                params={{ limit: 20, natureName: '申办方' }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={option => this.handleChange(option, 'sponsor')}
                            />
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="CRO" {...commonLayout}>
                            {
                                getFieldDecorator('croId')(
                                    <Input type="hidden" />
                                )
                            }
                            <SearchRetrieve
                                keyword='customerCompanyName'
                                style={{ width: '100%' }}
                                placeholder="输入名称检索"
                                value={cro}
                                params={{ limit: 20, natureName: 'CRO' }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={option => this.handleChange(option, 'cro')}
                            />
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石计划负责中心数量' {...commonLayout}>
                            {
                                getFieldDecorator('siteAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入津石计划负责中心数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石计划知情数量' {...commonLayout}>
                            {
                                getFieldDecorator('informedAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入津石计划知情数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石计划筛选数量' {...commonLayout}>
                            {
                                getFieldDecorator('filterAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入津石计划筛选数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石计划随机(入组)数量' {...commonLayout}>
                            {
                                getFieldDecorator('randomAmount')(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入津石计划随机(入组)数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='合同计划中心数量' {...commonLayout}>
                            {
                                getFieldDecorator('contractSitePlanAmount', {
                                    rules: [
                                        { required: true, message: '请输入合同计划中心数量' },
                                    ],
                                })(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入合同计划中心数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='合同计划随机(入组)数量' {...commonLayout}>
                            {
                                getFieldDecorator('contractRandomPlanAmount', {
                                    rules: [
                                        { required: true, message: '请输入合同计划随机(入组)数量' },
                                    ],
                                })(
                                    <InputNumber style={{ width: '100%' }} min={0} formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} placeholder="请输入合同计划随机(入组)数量" />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石第一家研究中心启动计划开始时间' {...commonLayout}>
                            {
                                getFieldDecorator('firstSiteStartTime', {
                                    rules: [
                                        { required: true, message: '请选择津石第一家研究中心启动计划开始时间' },
                                    ],
                                })(
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                    />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石100%中心启动计划开始时间' {...commonLayout}>
                            {
                                getFieldDecorator('oneHundredPercentSiteStartTime', {
                                    rules: [
                                        { required: true, message: '请选择津石100%中心启动计划开始时间' },
                                    ],
                                })(
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                    />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石首例受试者随机（入组）计划开始时间' {...commonLayout}>
                            {
                                getFieldDecorator('firstPatientGroupStartTime', {
                                    rules: [
                                        { required: true, message: '请选择津石首例受试者随机（入组）计划开始时间' },
                                    ],
                                })(
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                    />
                                )
                            }
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label='津石100%受试者随机（入组）计划开始时间' {...commonLayout}>
                            {
                                getFieldDecorator('oneHundredPercentGroupStartTime', {
                                    rules: [
                                        { required: true, message: '请选择津石100%受试者随机（入组）计划开始时间' },
                                    ],
                                })(
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        format={dateFormat}
                                        placeholder="请选择"
                                    />
                                )
                            }
                        </FormItem>
                    </Col>
                </Row>
                <div>2.项目负责人</div>
                <Row>
                    <Col span={12}>
                        <FormItem label="BD" {...commonLayout}>
                            {
                                getFieldDecorator('bdUserId', {
                                    rules: [
                                        { required: true, message: '请选择BD' },
                                    ],
                                })(
                                    <Input type="hidden" />
                                )
                            }
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: '100%' }}
                                placeholder="输入姓名/工号检索"
                                value={bdUserName}
                                params={{ limit: 20, dimissionStatus: 'WORKING' }}
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={option => this.handleChange(option, 'bd')}
                            />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }
}

class CreateModal extends Component {
    state = {
        loading: false,
        dictLoading: false,
        treatmentMethodList: [],
        administrationModeList: [],
    }

    dictLoaded = false
    dictLoadTimer = null

    componentDidMount() {
        Constants = getStatusByType('add');
    }

    // 字典延迟到首次打开弹窗时加载，避免列表页挂载即预载；失败不置 dictLoaded，重开可重试
    componentWillReceiveProps(nextProps) {
        if (nextProps.visible && !this.props.visible && !this.dictLoaded) {
            this.loadDictData();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.dictLoadTimer);
    }

    loadDictData = () => {
        this.setState({ dictLoading: true });
        // 兜底：请求失败时 doneResult 不执行，15s 后强制结束 loading（下拉为空，重开可重试）
        clearTimeout(this.dictLoadTimer);
        this.dictLoadTimer = setTimeout(() => {
            this.setState({ dictLoading: false });
        }, 15000);
        this.queryByParams(
            { key: 'Treatment_Method', name: 'treatmentMethodList' },
            { key: 'Administration_Mode', name: 'administrationModeList'}
        );
    }

    queryByParams = (...rest) => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const params = {};
                res.typeConfigureList.forEach(i => {
                    const { name } = rest.find(r => r.key === i.typeName) || {};
                    if (name) {
                        if (!params[name]) {
                            params[name] = [];
                        }
                        params[name].push(i);
                    }
                });
                this.dictLoaded = true;
                clearTimeout(this.dictLoadTimer);
                this.setState({
                    ...params,
                    dictLoading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.props.showCreate(false);
    }

    // 提交表单
    handleSubmit = () => {
        if (this.state.loading) {
            return;
        }
        this.form.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const {
                stageIds,
                suspendTime,
                investigationByStageId,
                ...saveParams
            } = values;
            const { bdUserId, firstSiteStartTime, oneHundredPercentSiteStartTime, firstPatientGroupStartTime, oneHundredPercentGroupStartTime } = saveParams;

            saveParams[`users[0].userId`] = bdUserId;
            saveParams[`users[0].roleCode`] = 'BD';
            saveParams.stageIds = stageIds.join(',');
            saveParams.investigationByStageId = investigationByStageId.join(',');

            if (suspendTime) {
                saveParams.suspendTime = suspendTime.format(dateFormat);
            }
            const { investigationMedicineType = [] } = values
            this.props.saveParams({ ...values });
            saveParams.investigationMedicineType = investigationMedicineType[0];
            saveParams.secondResearchProductType = investigationMedicineType[1];
            saveParams.firstSiteStartTime = firstSiteStartTime ? firstSiteStartTime.format(dateFormat) : undefined;
            saveParams.oneHundredPercentSiteStartTime = oneHundredPercentSiteStartTime ? oneHundredPercentSiteStartTime.format(dateFormat) : undefined;
            saveParams.firstPatientGroupStartTime = firstPatientGroupStartTime ? firstPatientGroupStartTime.format(dateFormat) : undefined;
            saveParams.oneHundredPercentGroupStartTime = oneHundredPercentGroupStartTime ? oneHundredPercentGroupStartTime.format(dateFormat) : undefined;
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: Constants.saveUrl,
                data: {
                    enterpriseId: 1,
                    ...saveParams,
                },
                dataType: 'json',
                doneResult: () => {
                    message.success(Constants.success);
                    this.setState({
                        loading: false,
                    }, () => {
                        this.props.saveParams({});
                        this.hide();
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            };
            $.sendRequest(options);
        });
    }

    render() {
        const {
            params,
            visible,
            areaList,
            typeList,
            levelList,
            stageList,
            businessList,
            testeeTypeList,
            GlobalTypeList,
            MedicineTypeList,
        } = this.props;
        const { loading, dictLoading, treatmentMethodList, administrationModeList } = this.state;

        const obj = {};
        for (let [key, value] of Object.entries(params)) {
            obj[key] = { value };
        }
        const mapPropsToFields = () => ({
            isClinicalProject: { value: 1 },
            ...obj
        });
        CreateForm = Form.create({ mapPropsToFields })(CreateForm);

        const settings = {
            areaList,
            typeList,
            levelList,
            stageList,
            businessList,
            testeeTypeList,
            GlobalTypeList,
            MedicineTypeList,
            treatmentMethodList,
            administrationModeList,
        };

        return (
            <Modal
                title={Constants.title}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal form-item-padding"
                width="1250px"
                confirmLoading={loading}
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
            >
                <Spin spinning={loading || dictLoading}>
                    <CreateForm
                        ref={el => this.form = el}
                        {...settings}
                    />
                </Spin>
            </Modal>

        );
    }
}

const mapStateToProps = (state) => ({
    params: state.investigationState.createParams || {},
});

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveParams(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateModal);



// WEBPACK FOOTER //
// ./src/components/investigation/CreateModal.js